import {PriceStore} from "../store/price.store";

export class SelectSolutionComponent {
    readonly activeClasses = {
        active: 'active',
        activeFlex: 'active-flex'
    };
    private solutionSwitch: HTMLInputElement | null;
    private solutionOptions: HTMLElement[] | null;
    private solutionList: HTMLElement | null;
    private tabContents: HTMLElement[] | null;
    private tabButtons: HTMLElement[] | null
    constructor(
        private container: HTMLElement,
        private priceStore: PriceStore
    ) {
        this.solutionSwitch = this.container.querySelector('[data-solution-switch]');
        this.solutionOptions = Array.prototype.slice.call(this.container.querySelectorAll('[data-solution-option]'));
        this.solutionList = this.container.querySelector('[data-solution-list]');
        this.tabContents = Array.prototype.slice.call(this.container.querySelectorAll('[data-tab-content]'));
        this.tabButtons = Array.prototype.slice.call(this.container.querySelectorAll('[data-tab-btn]'));

    }

    public initialize(): void {
        this.solutionOptions?.forEach((solutionOption, index) => {
            solutionOption.addEventListener('click', () => {
                if (this.solutionSwitch) {
                    this.solutionSwitch.checked = false;
                }
                this.priceStore.setSolutionIndex(index);
                this.solutionList?.classList.remove(this.activeClasses.active);
                this.tabContents?.forEach(tabContent => {
                    tabContent.classList.remove(this.activeClasses.activeFlex);
                });
                this.tabButtons?.forEach((tabBtn: HTMLElement) => {
                    tabBtn.classList.remove(this.activeClasses.active);
                });
                if (this.tabContents && this.tabContents.length > 0)
                this.tabContents[index].classList.add(this.activeClasses.activeFlex);
                if (this.tabButtons && this.tabButtons.length > 0)
                this.tabButtons[index].classList.add(this.activeClasses.active);
            });
        });
        if (this.solutionSwitch)
        this.solutionSwitch.addEventListener('click', (e) => {
            this.solutionList?.classList.add(this.activeClasses.active);
        });
    }
}
